var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.initialized
    ? _c(
        "section",
        {
          staticClass:
            "box-typical box-typical-dashboard panel panel-default scrollable"
        },
        [
          _c("header", { staticClass: "box-typical-header panel-heading" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-rounded btn-secondary float-right btn-sm",
                attrs: { href: "#" + _vm.endpoint }
              },
              [_vm._v("View all")]
            ),
            _vm._v(" "),
            _c("h3", { staticClass: "panel-title" }, [
              _vm._v(_vm._s(_vm.label))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "box-typical-body panel-body" }, [
            _vm._.isEmpty(_vm.itemData)
              ? _c("div", { class: ["alert", "alert-info", "m-0"] }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.emptyText || "No record") +
                      "\n        "
                  )
                ])
              : _c("table", { staticClass: "table table-dashboard" }, [
                  _c("thead", [
                    _c(
                      "tr",
                      _vm._l(_vm.fields, function(field) {
                        return _c("th", { key: field.name }, [
                          _c("div", { staticClass: "pl-1" }, [
                            _vm._v(_vm._s(field.label))
                          ])
                        ])
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.itemData, function(item) {
                      return _c(
                        "tr",
                        {
                          key: item.id,
                          staticClass: "clickable",
                          on: {
                            click: function($event) {
                              return _vm.gotoItem(item.id)
                            }
                          }
                        },
                        _vm._l(_vm._.keys(_vm.fields), function(key) {
                          return _c("td", {
                            key: key,
                            domProps: {
                              innerHTML: _vm._s(_vm._.get(item, key, ""))
                            }
                          })
                        }),
                        0
                      )
                    }),
                    0
                  )
                ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c4cce5e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c4cce5e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/dashboard-elements/TablePanelComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2c4cce5e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/dashboard-elements/TablePanelComponent.vue
// module chunks = 0